// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as actions from '../actions'
import Login from '../components/Login/Login'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {Match, RouterHistory} from 'react-router'

export type StateProps = {
  accessToken: ?string,
  isLogging: boolean,
  error: ?string,
  userId: ?string,
  isAdmin: boolean
};

export type OwnProps = {
  match: ?Match,
  history: RouterHistory
};

export type DispatchProps = {
  login: $PropertyType<typeof actions, 'login'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = (state: State) => ({
  accessToken: state.authentication.accessToken,
  isLogging: state.authentication.isLogging,
  error: state.authentication.error,
  userId: state.authentication.userId,
  isAdmin: state.authentication.isAdmin
})

const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => {
  return bindActionCreators({...actions}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
